<template>
  <b-modal
    v-model="shown"
    size="md"
    centered
    no-close-on-esc
    no-close-on-backdrop
    hide-footer
    hide-header >
    <p><strong>Are you sure you want to delete this file?</strong></p>

    <p v-if="file">
      <strong>File Name:</strong>
      {{file.originalName}}
    </p>

    <div class="mt-4">
      <b-button variant="outline-danger" class="px-3 mr-2" @click="onDelete" :disabled="isDeleting">
        <i class="fa fa-spinner fa-spin mr-2" v-if="isDeleting"></i>
        Yes, Delete
      </b-button>
      <b-button class="px-3" @click="() => $emit('close')" :disabled="isDeleting">
        Cancel
      </b-button>
    </div>
  </b-modal>
</template>

<script>
  import {deleteUploadedFile} from '../../store/files';

  export default {
    name: 'ConfirmDelete',

    props: {
      fileID: String
    },

    data() {
      return {
        shown: true,
        isDeleting: false
      };
    },

    computed: {
      file() {
        return this.$store.getters.getFile(this.fileID);
      }
    },

    methods: {
      onDelete() {
        this.isDeleting = true;
        this.$store.dispatch(deleteUploadedFile(this.fileID))
          .catch(console.log)
          .finally(() => this.$emit('close'))
      }
    }

  };
</script>

<style scoped>

</style>
